// extracted by css-extract-rspack-plugin
export default {"container":"FeatureTags-module__container","tagWrapper":"FeatureTags-module__tagWrapper","icon":"FeatureTags-module__icon"};